/**
 * App Mode Utilities
 *
 * Manages App Mode preference in localStorage for guest users.
 * Authenticated users have this preference synced via DynamoDB through UserSettings.
 */

const APP_MODE_STORAGE_KEY = 'systemdox_app_mode';

/**
 * Get the App Mode preference from localStorage
 * @returns true if App Mode is enabled, false otherwise
 */
export const getAppModePreference = (): boolean => {
  const stored = localStorage.getItem(APP_MODE_STORAGE_KEY);
  return stored === 'true';
};

/**
 * Save the App Mode preference to localStorage
 * @param enabled - Whether App Mode should be enabled
 */
export const setAppModePreference = (enabled: boolean): void => {
  localStorage.setItem(APP_MODE_STORAGE_KEY, String(enabled));
};

/**
 * Detect if the current device is a mobile device using screen width and touch support.
 * Returns true for phones and small tablets.
 */
export const isMobileDevice = (): boolean => {
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const isNarrow = window.innerWidth <= 768;
  return hasTouch && isNarrow;
};
